import { render, staticRenderFns } from "./PolizasRMSCard.vue?vue&type=template&id=3c2dbbf9&scoped=true&"
import script from "./PolizasRMSCard.vue?vue&type=script&lang=js&"
export * from "./PolizasRMSCard.vue?vue&type=script&lang=js&"
import style0 from "./PolizasRMSCard.vue?vue&type=style&index=0&id=3c2dbbf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2dbbf9",
  null
  
)

export default component.exports